import { createSelector } from "@reduxjs/toolkit";

import { nodeDesignsByIdSelector } from "../selectors/nodeDesignsCoreSelectors.ts";

export const getNodeIdExistsSelector = createSelector(
  [nodeDesignsByIdSelector],
  (designsById) => (id: number) => !!designsById[id],
);
